import LegalPage from "@/components/legal/LegalPage";

const H2 = {
  color: '#f7f7f7',
  fontSize: 18,
  fontWeight: 700,
  marginTop: 24,
  marginBottom: 10,
  letterSpacing: '0.2px'
};

const H3 = {
  color: '#f7f7f7',
  fontSize: 15,
  fontWeight: 700,
  marginTop: 20,
  marginBottom: 8,
  letterSpacing: '0.2px'
};

const A = {
  color: '#C9A86A',
  textDecoration: 'underline'
};

export default function Contact() {
  return (
    <LegalPage title="Contact" testid="legal-contact">
      <>
        <h2 style={H2}>Overview</h2>
        <p>
          If you need help with your CDI Collectables account, have questions about your subscription,
          or want to report an issue, you can reach our support team using the contact details below.
          We aim to respond as soon as reasonably possible, though response times may vary during peak periods.
        </p>

        <h2 style={H2}>Email Support</h2>
        <p>
          For general enquiries, technical support, or account questions, email us at <a style={A} href="mailto:support@cdicollectables.co.nz">support@cdicollectables.co.nz</a>.
        </p>

        <h2 style={H2}>Postal Address</h2>
        <p>
          Calbydoneit Limited (CDI Collectables)<br />
          Glenfield, Auckland 0629<br />
          New Zealand
        </p>

        <h2 style={H2}>Response Times</h2>
        <p>
          We typically reply within 1–2 business days. During busy periods, replies may take longer,
          but we will always do our best to assist you as quickly as possible.
        </p>
      </>
    </LegalPage>
  );
}
